module.exports = __webpack_public_path__ + "img/imp copy.e161cdd3.svg";